import { render } from "./SendAskMoney.vue?vue&type=template&id=7a7ad906&scoped=true&ts=true"
import script from "./SendAskMoney.vue?vue&type=script&lang=ts"
export * from "./SendAskMoney.vue?vue&type=script&lang=ts"

import "./SendAskMoney.vue?vue&type=style&index=0&id=7a7ad906&scoped=true&lang=sass"

import exportComponent from "/home/vaab/dev/js/monujo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a7ad906"]])

export default __exports__